function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VRadioGroup, VRadio } from 'vuetify/lib';
import FormMixin from '../form.mixin';

var Checkbox = /*#__PURE__*/function () {
  function Checkbox() {
    _classCallCheck(this, Checkbox);
  }

  _createClass(Checkbox, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-radio-button-group', {
        template: '<v-radio-group class="radio-button" v-bind="bind" v-on="$listeners" @change="$emit(\'input\', $event)" :rules="rules"><slot></slot></v-radio-group>',
        mixins: [FormMixin],
        components: {
          VRadioGroup: VRadioGroup
        }
      });
      Vue.component('roche-radio-button', {
        template: '<v-radio :ripple="false" v-bind="Object.assign({}, $props, $attrs)" v-on="$listeners" @change="$emit(\'input\', $event)"></v-radio>',
        // mixins: [FormMixin],
        components: {
          VRadio: VRadio
        }
      });
    }
  }]);

  return Checkbox;
}();

export default Checkbox;